import { visualizeSinglePatentInput } from './dashboards'
import { z } from 'zod'

const positionSchema = z.tuple([z.number(), z.number()]).transform((data) => ({
  x: data[0],
  y: data[1],
}))

const topicLabelSchema = z.number().int().min(-1)

export const landscapingResultSchema = z.object({
  document_number: z.string(),
  topic_label: topicLabelSchema,
  data_point: positionSchema,
})

export type LandscapingResultPoint = z.infer<typeof landscapingResultSchema>

export const topicSchema = z.object({
  label: topicLabelSchema,
  centroid: positionSchema,
  title: z.string(),
  keywords: z.array(z.string()),
  patents_count: z.number().int().nonnegative(),
})

export type Topic = z.infer<typeof topicSchema>

export const landscapeSchema = z.object({
  id: z.string(),
  status: z.enum(['in_progress', 'successful', 'failed']),
  number_of_clusters: z.number().int().nonnegative().nullable().default(null),
  patents: z.array(visualizeSinglePatentInput),
  landscaping_results: z.array(landscapingResultSchema),
  topics: z.array(topicSchema),
  custom_dimension_field: z.string().nullable().default(null),
  custom_dimension_config: z.object({
    topics: z.record(z.string(), z.string()).optional(),
  }),
})

export type Landscape = z.infer<typeof landscapeSchema>

export const landscapeListSchema = landscapeSchema
  .pick({
    id: true,
    status: true,
    number_of_clusters: true,
  })
  .extend({
    created_at: z.string(),
  })

export type LandscapeList = z.infer<typeof landscapeListSchema>

export const LandscapeUpdateSchema = landscapeSchema.pick({
  id: true,
  custom_dimension_field: true,
  custom_dimension_config: true,
})
